import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { IPartnerRatingByPartner, IServiceType } from '../../../interfaces';
import { V2_COLUMN_GROUPS } from './constants';
import PartnerRatingColGroup from './PartnerRatingColGroup';
import PartnerRatingTableRow from './PartnerRatingTableRow';
import { useBorderedTableStyles } from '../borderedTable.styles';

interface IProps {
  data: IPartnerRatingByPartner;
  year: number;
  serviceType?: IServiceType;
}

const PartnerRatingTable = ({ data, year, serviceType }: IProps) => {
  const borderedTableClasses = useBorderedTableStyles();
  // Вид услуги берём из карточки, справочник вкладок — подстраховка
  const serviceTypeKind = data.serviceTypeKind ?? serviceType?.type;
  const columnGroups = V2_COLUMN_GROUPS(serviceTypeKind);

  return (
    <TableContainer style={{ width: 'calc(100% + 48px)', margin: '0 -24px', maxHeight: 500, overflow: 'auto' }}>
      <Table stickyHeader size="small" className={borderedTableClasses.table} style={{ tableLayout: 'fixed' }}>
        <PartnerRatingColGroup />

        <TableHead>
          <TableRow>
            <TableCell rowSpan={2}>
              <b>ЖК</b>
            </TableCell>

            {columnGroups.map((group) => (
              <TableCell key={group.title} align="center" colSpan={group.columns.length}>
                <b>{group.title}</b>
              </TableCell>
            ))}
          </TableRow>

          <TableRow>
            {columnGroups.flatMap((group) =>
              group.columns.map((column) => (
                <TableCell key={column} align="center">
                  {column}
                </TableCell>
              )),
            )}
          </TableRow>
        </TableHead>

        <TableBody>
          {data.realEstates.map((realEstateRating) => (
            <PartnerRatingTableRow
              key={realEstateRating.realEstateGuid}
              year={year}
              serviceType={serviceType}
              serviceTypeKind={serviceTypeKind}
              partnerRating={data}
              realEstateRating={realEstateRating}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PartnerRatingTable;
